export default __webpack_public_path__ + "static/media/bing.c573bab9.ogg";